var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shape-control-handle",style:(`transform: translate(${_vm.x}px, ${_vm.y}px)`),on:{"mousedown":_vm.move}})
}
var staticRenderFns = []

export { render, staticRenderFns }